<div class="column is-full">
    <div class="columns">
        <div class="column is-3 has-text-left-mobile has-text-centered-tablet user-description">
            <div class="columns is-mobile is-multiline">
                <div class="column is-one-quarter-mobile is-12-tablet has-text-centered is-paddingless">
                    <span class="icon is-large">
                        <i class="tri-user" aria-hidden="true"></i>
                    </span>
                </div>
                <div class="column is-paddingless">
                    @if (review.user.login) {
                        <p class="is-marginless has-text-weight-bold" [innerHTML]="review.user.login"></p>
                    }
                    <div>
                        <p class="is-size-7 is-marginless">
                            @if (review.user.gender) {
                                @if (review.user.gender === 'Male') {
                                    <span>Homme</span>
                                }
                                @if (review.user.gender === 'Female') {
                                    <span>Femme</span>
                                }
                                <span class="is-hidden-tablet">&nbsp;</span>
                                <br class="is-hidden-mobile" />
                            }
                            @if (review.user.ageLabel) {
                                <span>{{ review.user.ageLabel }}</span>
                            }
                        </p>
                    </div>
                    @if (review.user.verified) {
                        <span class="is-marginless icon-and-text text is-level-2">
                            <span class="icon is-success">
                                <i class="tri-check-circle"></i>
                            </span>
                            <span>Acheteur vérifié</span>
                        </span>
                    }
                </div>
            </div>
        </div>
        <div class="column">
            <trg-rating [rating]="review.note" max="5" marginless size="5"></trg-rating>
            <p class="title is-level-3 has-text-weight-light has-no-margin-top" [innerHTML]="review.title"></p>
            <p class="is-size-7 is-uppercase">
                <strong>
                    <small>Il y a {{ review.created_at | sinceLabel }}</small>
                </strong>
            </p>
            @if (review.recommanded) {
                <p class="icon-and-text text is-level-2">
                    <span class="icon" [ngClass]="review.recommanded ? 'is-success' : 'is-danger'">
                        <i
                            [ngClass]="review.recommanded ? 'tri-check-circle' : 'tri-times-circle'"
                            aria-hidden="true"
                        ></i>
                    </span>
                    {{ review.recommanded ? 'Oui, je recommande ce produit' : 'Non, je ne recommande pas ce produit' }}
                </p>
            }
            <p class="text is-level-2">
                @if (canShowMore && !showMore) {
                    {{ review.shortMessage }} ...
                } @else {
                    {{ review.message }}
                }
            </p>
            @if (review.message && canShowMore && !showMore) {
                <p class="text is-level-2">
                    <a (click)="showFullMessage()" class="link">En savoir plus</a>
                </p>
            }
            <div class="reviews-details" [ngClass]="{ 'hidden-xs hidden-sm': review.syndication }">
                @if (review.pros) {
                    <p class="pros text is-level-2">
                        <strong>Points forts :</strong>
                        {{ review.pros }}
                    </p>
                }
                @if (review.cons) {
                    <p class="cons text is-level-2">
                        <strong>Points faibles :</strong>
                        {{ review.cons }}
                    </p>
                }
                @if (review.recommendedFor) {
                    <p class="text is-level-2">
                        <strong>Je recommande ce produit pour :</strong>
                        {{ review.recommendedFor }}
                    </p>
                }
                @if (review.syndication) {
                    <p class="text is-level-2">
                        <img
                            class="image"
                            [src]="review.syndication.image"
                            height="20px"
                            width="20px"
                            alt="{{ review.syndication.name }}"
                        />
                        <span class="text">Publié à l'origine sur {{ review.syndication.name }}</span>
                    </p>
                }
            </div>
        </div>
    </div>
    <hr class="is-divider" />
</div>
